import Api from '@/services/http'
import type * as Types from './types'

/** 获取汇率 */
export const fetchRateList = async (params: Types.RateParam) => Api.admin.post<Types.RateResItem>('/api/currency/convert', params)

export const enum EnumFileTypes {
  invoicePath = 'invoicePath',
}

export type IOSSItem = {
  fileType: `${EnumFileTypes}`
  ossUri: string
}

/**
 *
 * @param ossUriRes
 * @param fileType
 * @returns
 */
export const getOssAccessLinks = (data: IOSSItem[]) => {
  return Api.toast.post<{
    res: Array<{
      ossUri: string
      result: string
    }>
  }>('/api/presigned/oss', {
    uris: data,
  })
}
